module.exports = __webpack_public_path__ + "11_hair_silver.bc9d3c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/11_hair_silver.png
// module id = QTDD
// module chunks = 0